import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { ChevronDownIcon } from '../../../../core/themes/icons/ChevronDownIcon';
import { ChevronRightIcon } from '../../../../core/themes/icons/ChevronRightIcon';

const styles = () => ({
  colTitle: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontSize: '13px',
    zIndex: 1
  },
  centerAndBorder: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: '1px solid #E0E0E0',
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  topLeft: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1em'
  },
  rowTitle: {
    fontSize: '13px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '8px',
    paddingRight: '8px'
  },
  rowTitleParent: {
    width: '100%!important'
  },
  indent_1: {
    paddingLeft: '30px !important'
  },
  indent_2: {
    paddingLeft: '60px !important'
  },
  rowTitleLabel: {
    fontSize: '13px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '200px'
  },
  rowTitleLabelOverflow: {
    fontSize: '13px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'visible',
    maxWidth: '200px'
  }
});

/**
 * Wrapper to display or not the tooltip
 * @param {*} props
 */
const TooltipWrapper = ({ label, children }) => {
  if (!label) {
    return children;
  } else {
    return (
      <Tooltip placement="top" title={label}>
        {children}
      </Tooltip>
    );
  }
};

export const TableCellWithCheckbox = withStyles(styles)(
  ({
    classes,
    id,
    label,
    disabled,
    checked,
    indeterminate,
    handleCheckboxChange
  }) => {
    const extraProps = disabled
      ? { disabled: true }
      : { onChange: handleCheckboxChange };

    return (
      <TooltipWrapper label={label}>
        <input
          type="checkbox"
          value={id}
          checked={checked}
          ref={el => el && (el.indeterminate = indeterminate)}
          {...extraProps}
          id={id}
        />
      </TooltipWrapper>
    );
  }
);

export const RowTitle = withStyles(styles)(
  ({ data, textOverflow, classes, onRowChange }) => {
    const { indentation, label, tooltipLabel, displayId, expand } = data;

    const text = (
      <Tooltip
        placement="top"
        disableHoverListener={displayId === '*'}
        title={tooltipLabel || ''}
      >
        <Typography
          variant="body1"
          component="div"
          classes={{
            root: textOverflow
              ? classes.rowTitleLabelOverflow
              : classes.rowTitleLabel
          }}
        >
          {label}
        </Typography>
      </Tooltip>
    );

    let clName = classes.rowTitle;
    if (indentation > 0) {
      clName += ' ' + classes[`indent_${indentation}`];
    }
    return (
      <div className={clName}>
        {data.children ? (
          <Grid
            container
            className={classes.rowTitleParent}
            wrap="nowrap"
            spacing={1}
          >
            <Grid
              item
              onClick={onRowChange}
              classes={{ item: classes.arrowGroupGridItem }}
            >
              {data.children ? (
                expand ? (
                  <ChevronDownIcon />
                ) : (
                  <ChevronRightIcon />
                )
              ) : null}
            </Grid>
            <Grid item xs={11} classes={{ root: classes.rowTitleLabels }}>
              {text}
            </Grid>
          </Grid>
        ) : (
          text
        )}
      </div>
    );
  }
);

export const ColumnTitle = withStyles(styles)(({ label, center, classes }) => (
  <Tooltip placement="top" title={label}>
    <div className={center ? classes.centerAndBorder : classes.topLeft}>
      <div className={classes.colTitle}>{label}</div>
    </div>
  </Tooltip>
));
